export default {
  tabs: [
    {
      // 该功能的入口在评估师工作台 =》 [NCNB]收车审核详情页 =》 复检定价 =》 查看定价时复检报告；
      // 价格管理工作台 =》 定价列表详情 =》 复检报告概要中的 =》 查看报告
      name: 'RecheckReport',
      path: '/recheckReport',
      component: () => import('./src/RecheckReport.vue'),
      meta: {
        title: '复检报告',
      },
    },
  ],
}
